const WORKER_BASE = "https://aitu-schedule-ics-gateway.aitu-schedule.workers.dev";

export async function fetchCalendarIcs(moodleUrl: string): Promise<string> {
  const u = `${WORKER_BASE}/api/ics?url=${encodeURIComponent(moodleUrl)}`;
  const r = await fetch(u, { headers: { Accept: "text/calendar,*/*" } });
  const text = await r.text();
  if (!r.ok) throw new Error(`ICS error ${r.status}: ${text.slice(0, 200)}`);
  return text;
}
